import { Deserializable } from "./deserializable";

export class Pet implements Deserializable {
  id: string;
  name: string;
  gender: string;
  age: string;
  breed: string;
  description: string;
  image: string;
  price: number;
  adopted: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export const PETS: Pet[] = [

    {
        id: 'frenchie-daisy', name: 'DAISY', image: 'assets/img/frenchie/daisy.jpg',
        gender: 'Female', age: "9 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: false,
        description: "This sweet little frenchie is Daisy, a family raised French Bulldog puppy! She has the most adorable scrunchy face and she can’t wait to give you lots of love and puppy kisses. Daisy is vet checked, up to date on shots and dewormer, plus we provide a 1 Year genetic health guarantee. This cutie is registered with the AKC and both parents live on the premises.",
    } as Pet,

    {
        id: 'frenchie-diesel', name: 'DIESEL', image: 'assets/img/frenchie/diesel.jpeg',
        gender: 'Male', age: "9 Weeks", price: 750,
         breed: "French Bulldog",
         adopted: true,
        description: "Here comes Diesel, a beautiful French Bulldog puppy ready to put a smile on your face! This angelic pup is vet checked and up to date on shots and wormer.",
    } as Pet,

    {
        id: 'frenchie-enzo', name: 'ENZO', image: 'assets/img/frenchie/enzo.jpg',
        gender: 'Male', age: "10 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: true,
        description: "Check out, Enzo! He is an adorable French Bulldog puppy with a bubbly spirit. This precious little guy loves to play and is ready to join in all of your family activities.",
    } as Pet,

    {
        id: 'frenchi-frankie', name: 'FRANKIE', image: 'assets/img/frenchie/frankie.jpg',
        gender: 'Male', age: "9 Weeks", price: 750,
        breed: "French Bulldog",
        adopted: false,
        description: "Frankie is a precious little French Bulldog puppy who is just as cute as can be! This social little guy is vet checked and up to date on shots and wormer. He is registered with the AKC and Potty Trained, plus comes with a health guarantee provided by the breeder. Frankie is family raised with children and he loves to cuddle and play.",
    } as Pet,

    {
        id: 'frenchie-gizmo', name: 'GIZMO', image: 'assets/img/frenchie/gizmo.jpg',
        gender: 'Male', age: "10 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "He is a bundle of joy to any loving and caring Friendly. Puppy is well socialized at this young age. They are living in our kitchen to ensure they are used to the day to day activities of a busy household. They are well mauled and played with daily. We often have visitors/friends come and play with the puppies as well. They adapt fairly quickly to new situations.",
    } as Pet,

    {
        id: 'frenchie-gucci', name: 'GUCCI', image: 'assets/img/frenchie/gucci.jpg',
        gender: 'Male', age: "9 Weeks", price: 750,
        breed: "French Bulldog",
        adopted: false,
        description: "Check out, Gucci! He is an adorable French Bulldog puppy with a bubbly spirit. This precious little guy loves to play and is ready to join in all of your family fun. Gucci is vet checked and up to date on shots and wormer. He is registered with the AKC, plus comes with a health guarantee provided by us.",
    } as Pet,

    {
        id: 'frenchie-hugo', name: 'HUGO', image: 'assets/img/frenchie/hugo.jpg',
        gender: 'Male', age: "10 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "Hugo is a very special baby boy! He may be a baby now, but isn’t lacking when it comes to personality! He’s super friendly and loves everyone he meets! His coat is thick and soft. This baby is going to make a great companion and be very loyal to his family. Hugo is always doing something sweet to catch your attention and it always works! He is very affectionate and loves cuddling.",
    } as Pet,

    {
        id: 'frenchie-winston', name: 'WINSTON', image: 'assets/img/frenchie/winston.jpg',
        gender: 'Male', age: "11 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "He may be a baby now, but isn’t lacking when it comes to personality! He’s super friendly and loves everyone he meets! His coat is thick and soft. This baby is going to make a great companion and be very loyal to his family.",
    } as Pet,

    {
        id: 'frenchie-hank', name: 'Hank', image: 'assets/img/frenchie/hank.jpg',
        gender: 'Male', age: "10 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "He isn’t lacking when it comes to personality! He’s super friendly and loves everyone he meets! His coat is thick and soft. This baby is going to make a great friend and family member.",
    } as Pet,

    {
        id: 'frenchie-bentley', name: 'BENTLEY', image: 'assets/img/frenchie/bentley.jpg',
        gender: 'Male', age: "12 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "Charming Frenchie Bentley now ready to meet their new loving Friend. He is current on all shots, potty trained, and has an excellent pedigree. Will come with toys. We are looking for the perfect homes for him where he will be shown all love and care.",
    } as Pet,

    {
        id: 'frenchie-stitch', name: 'STITCH', image: 'assets/img/frenchie/stitch.jpg',
        gender: 'Male', age: "11 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: false,
        description: "He is current on all shots, potty trained, and has an excellent pedigree. Will come with toys. Parents are both health tested. We expect nothing less from these little ones.",
    } as Pet,

    {
        id: 'frenchie-jerry', name: 'JERRY', image: 'assets/img/frenchie/jerry.jpg',
        gender: 'Male', age: "9 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: true,
        description: "This sweet little frenchie is Jerry, a family raised French Bulldog puppy! He has the most adorable scrunchy face and he can’t wait to give you lots of love.",
    } as Pet,

    {
        id: 'frenchie-louie', name: 'LOUIE', image: 'assets/img/frenchie/louie.jpg',
        gender: 'Female', age: "10 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: true,
        description: "Louie is a precious little French Bulldog puppy who is just as cute as can be! This social gal is vet checked and up to date on shots and wormer.",
    } as Pet,

    {
        id: 'frenchie-luna', name: 'LUNA', image: 'assets/img/frenchie/luna.jpg',
        gender: 'Female', age: "9 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: false,
        description: "Luna is a wonderful loving little French Bulldog puppy, with a curious personality. She is a gorgeous female pup that wants to light up your life. Luna will have a complete nose to tail vet check and arrive with a current health certificate. She will love running around town with you doing errands or snuggling at home to relax. Luna is well socialized and eager to find her forever home.",
    } as Pet,

    {
        id: 'frenchie-olive', name: 'OLIVE', image: 'assets/img/frenchie/olive.jpeg',
        gender: 'Female', age: "9 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: false,
        description: "This sweet little frenchie is Olive, a family raised French Bulldog puppy! She has the most adorable scrunchy face and she can’t wait to give you lots of love and puppy kisses. Olive is vet checked, up to date on shots and dewormer, plus we provide a 1Year genetic health guarantee. This cutie is registered with the AKC and both parents live on the premises.",
    } as Pet,

    {
        id: 'frenchie-ollie', name: 'OLLIE', image: 'assets/img/frenchie/ollie.jpg',
        gender: 'Female', age: "10 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: false,
        description: "Charming Frenchie Ollie now ready to meet their new loving Friendly. She is current on all shots, potty trained, and has an excellent pedigree. Will come with toys. We are looking for the perfect homes for her where she will be shown all love and care. Parents are both health tested. We expect nothing less from these little ones.",
    } as Pet,

    {
        id: 'frenchie-oscar', name: 'OSCAR', image: 'assets/img/frenchie/oscar.jpg',
        gender: 'Male', age: "10 Weeks", price: 650,
        breed: "French Bulldog",
        adopted: true,
        description: "Charming Frenchie Ollie now ready to meet their new loving Friendly. She is current on all shots, potty trained, and has an excellent pedigree. Will come with toys. We are looking for the perfect homes for her where she will be shown all love and care. Parents are both health tested. We expect nothing less from these little ones.",
    } as Pet,

    {
        id: 'frenchie-sophie', name: 'SOPHIE', image: 'assets/img/frenchie/sophie.jpg',
        gender: 'Female', age: "9 Weeks", price: 800,
        breed: "French Bulldog",
        adopted: false,
        description: "This sweet little frenchie is Sophie, a family raised French Bulldog puppy! She has the most adorable scrunchy face and she can’t wait to give you lots of love and puppy kisses. Sophie is vet checked, up to date on shots and dewormer, plus we provide a 1Year genetic health guarantee. This cutie is registered with the AKC and both parents live on the premises.",
    } as Pet,

    // {
    //     id: 'princess', name: 'PRINCESS', image: 'assets/img/frenchie/princess.jpeg',
    //     gender: 'Female', age: "11 Weeks", price: 750,
    //     breed: "French Bulldog",
    //      adopted: false,
    //     description: "This sweet little gem is Princess, a family raised Husky puppy! She has the most adorable scrunchy face and she can’t wait to give you lots of love and puppy kisses. Princess is vet checked, up to date on shots and dewormer, plus we provide a 1Year genetic health guarantee. This cutie is registered with the AKC and both parents live on the premises.",
    // } as Pet,

];
  